import { ITranslationItems } from './language.types';

export const LABELS: ITranslationItems = {
  filter: {
    nl: 'Filter',
    en: 'Filter',
  },
  loadMore: {
    nl: 'Meer artikelen',
    en: 'More articles',
  },
  close: {
    nl: 'Sluiten',
    en: 'Close',
  },
  noItems: {
    nl: 'Er zijn helaas geen artikelen beschikbaar over dit onderwerp.',
    en: 'Unfortunately there are no articles available on this topic.',
  },
};

export const TYPE_LABELS: ITranslationItems = {
  category: {
    nl: 'Categorie',
    en: 'Category',
  },
  'content-type': {
    nl: 'Content type',
    en: 'Content type',
  },
  challenge: {
    nl: 'Challenge',
    en: 'Challenge',
  },
  segment: {
    nl: 'Segment',
    en: 'Segment',
  },
  sector: {
    nl: 'Sector',
    en: 'Sector',
  },
  topic: {
    nl: 'Topic',
    en: 'Topic',
  },
  product: {
    nl: 'Product',
    en: 'Product',
  },
  'product-category': {
    nl: 'Product category',
    en: 'Product category',
  },
};

export const VAR_LABELS = (amount: number) => ({
  showAmount: {
    nl: `Toon ${amount} ${amount === 1 ? 'resultaat' : 'resultaten'}`,
    en: `Show ${amount} ${amount === 1 ? 'result' : 'results'}`,
  },
});
